export function getAllMethods(): string[] {
  return [
    'files.read', 'files.write', 'files.edit', 'files.glob', 'files.grep',
    'shell.exec',
    'medical.vitals_query', 'medical.alert_trigger', 'medical.record_query',
    'gmail.send', 'gmail.read', 'gmail.template',
    'scheduling.followup_create', 'scheduling.calendar_check',
    'logging.create', 'logging.search', 'logging.update',
    'clinic_sync.clinical_logs',
    'memory.search', 'memory.list', 'memory.create', 'memory.update', 'memory.delete',
    'memory.working.push', 'memory.working.set', 'memory.working.clear',
  ];
}

export function getRoleMethods(): Record<string, string[]> {
  return {
    general_assistant: [
      'files.read', 'files.write', 'files.edit', 'files.glob', 'files.grep',
      'clinic_sync.clinical_logs',
      'memory.search', 'memory.list', 'memory.create', 'memory.update', 'memory.delete',
      'memory.working.push', 'memory.working.set', 'memory.working.clear',
    ],
    function: getAllMethods(),
  };
}
